<template>
  <Tooltip :max-width="width" :placement="placement" :content="content" :transfer="true">
    <div :style="`line-height: 32px;display: flex;align-items: center;color:${color}`">
        {{name}}
      <Icon :type="icon" :size="size" style="margin-left: 4px;" />
    </div>
  </Tooltip>
</template>

<script>
export default {
  props: {
    // 宽度
    width: {
      type: Number,
      default: 800
    },
    // 方向
    placement: {
      type: String,
      default: 'left'
    },
    // tooltip内容
    content: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: '说明'
    },
    // 颜色
    color: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'ios-help-circle'
    },
    size: {
      type: [String, Number],
      default: 16
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/common/PageTooltip.vue?1f21248a